import React from 'react';
import { Outlet } from 'react-router-dom';
import './index.scss';
const SimpleLayout = () => {
  return (
    <>
      <div className="logo"></div>
      <Outlet />
    </>
  );
};

export default SimpleLayout;
